import CONSTANTS from "@/Constants";

const TOTAL = Object.keys(CONSTANTS.APPOINTMENT_SCHEDULE_LEGEND).length;

// The status line on the settings sheet's filter card. An empty selection is the
// board's own "no filter" state rather than "nothing shown" -- the timeline only
// narrows when the list is non-empty -- so none selected and all selected
// describe the same board and have to read the same way.
//
// The noun stays plural because it agrees with the total, not the selection:
// "Showing 1 of 12 statuses" is the one-selected case.
export function statusFilterSummary(statuses: string[] = []): string {
  if (statuses.length === 0 || statuses.length >= TOTAL) {
    return "Showing all statuses";
  }
  return `Showing ${statuses.length} of ${TOTAL} statuses`;
}
